// src/components/pages/correlation/components/CorrelationExamples.js

import React from 'react';
import Plot from 'react-plotly.js';
import styles from '../style/CorrPage.module.css'; // 경로 수정 필요

function CorrelationExamples({ t }) {
  const nPoints = 50;
  
  const generatePerfectCorrelation = () => {
    const x = Array.from({ length: nPoints }, (_, i) => (i * 10) / nPoints);
    const y = x.slice();
    return { x, y };
  };
  const generatePerfectNegativeCorrelation = () => {
    const x = Array.from({ length: nPoints }, (_, i) => (i * 10) / nPoints);
    const y = x.map((x_i) => -x_i);
    return { x, y };
  };
  const generateUncorrelated = () => {
    const x = Array.from({ length: nPoints }, (_, i) => (i * 10) / nPoints);
    const y = Array.from({ length: nPoints }, () => Math.random() * 10);
    return { x, y };
  };
  const generateCorrelatedData = (correlation) => {
    const x = [];
    const y = [];
    for (let i = 0; i < nPoints; i++) {
      const x_val = Math.random() * 10;
      const noise = Math.random() * 2;
      // 통계적 상관관계 모델링을 단순화한 방식
      x.push(x_val);
      y.push(correlation * x_val + Math.sqrt(1 - correlation * correlation) * noise);
    }
    return { x, y };
  };

  const perfect = generatePerfectCorrelation();
  const perfectNeg = generatePerfectNegativeCorrelation();
  const uncorrelated = generateUncorrelated();
  const pos07 = generateCorrelatedData(0.7);
  const neg07 = generateCorrelatedData(-0.7);

  const plots = [
    { titleKey: "perfectPositive", data: perfect, corrKey: "perfectPositiveTitle" },
    { titleKey: "positive07", data: pos07, corrKey: "positive07Title" },
    { titleKey: "uncorrelated", data: uncorrelated, corrKey: "uncorrelatedTitle" },
    { titleKey: "negative07", data: neg07, corrKey: "negative07Title" },
    { titleKey: "perfectNegative", data: perfectNeg, corrKey: "perfectNegativeTitle" },
  ];

  return (
    <div className={styles["correlation-examples"]}>
      {plots.map((plot, index) => (
        <React.Fragment key={index}>
          <h3>{t(`correlation.scatter.${plot.titleKey}`)}</h3>
          <Plot
            data={[
              {
                x: plot.data.x,
                y: plot.data.y,
                mode: "markers",
                type: "scatter",
                marker: { size: 6 },
              },
            ]}
            layout={{
              title: t(`correlation.scatter.${plot.corrKey}`),
              width: 300,
              height: 300,
              margin: { l: 40, r: 40, t: 40, b: 40 },
              xaxis: { title: t("correlation.scatter.axisX") },
              yaxis: { title: t("correlation.scatter.axisY") },
            }}
          />
        </React.Fragment>
      ))}
    </div>
  );
}

export default CorrelationExamples;